import { Link } from "react-router-dom";
import { LegalLayout, H2, H3, P, List, Note } from "./LegalLayout";
import { FOUND_CONFIG, contactTarget } from "./foundConfig";

export default function Copyright() {
  const c = FOUND_CONFIG;
  const cc = contactTarget("copyright");

  return (
    <LegalLayout
      title="FOUND Copyright & Intellectual Property Policy"
      description="Copyright and IP rules for uploading music and video to FOUND, and how rights holders can report infringement."
    >
      <P>
        FOUND allows Artists to upload music and video, so respecting intellectual property is
        essential. This policy explains the rights you must hold to upload content and how copyright
        owners can report suspected infringement to <strong>{c.company}</strong>.
      </P>

      <H2>Artist responsibilities</H2>
      <P>Artists must own their uploaded material or hold all necessary licences, permissions and rights to use it. Uploading content to FOUND must not violate another person's:</P>
      <List items={[
        "Copyright",
        "Master recording rights",
        "Publishing rights",
        "Composition rights",
        "Performance rights",
        "Trademark rights",
        "Image / likeness rights",
        "Any other intellectual property rights",
      ]} />

      <H2>Reporting suspected infringement</H2>
      <P>
        If you believe content on FOUND infringes your rights, send a report with the information
        below. Submit it {cc.isEmail
          ? <>by email to <a href={cc.href} className="text-white underline">{cc.href.replace("mailto:", "")}</a></>
          : <>through the <Link to="/found/support" className="text-white underline">FOUND Support</Link> page (select “Copyright”)</>}.
      </P>
      <List items={[
        "Rights holder name",
        "Contact information",
        "The work being infringed",
        "The FOUND content being reported (links or identifying details)",
        "An explanation of your ownership or authority",
        "A good-faith statement that the use is not authorised by the rights holder, its agent or the law",
        "A statement, made under penalty of perjury where applicable, that the information is accurate and that you are the rights holder or authorised to act on their behalf",
      ]} />

      <H2>Our review process</H2>
      <P>We review copyright reports and, where appropriate, remove or restrict the reported content and may take action against repeat infringers, including account suspension or termination. We may request additional information and may forward reports to the relevant user where appropriate.</P>

      <H2>Counter-notifications</H2>
      <P>If your content was removed and you believe this was a mistake or that you hold the necessary rights, you may submit a counter-notification with your contact details, identification of the removed content, and a statement explaining your rights.</P>

      <Note>
        A dedicated copyright/DMCA agent contact will be published here once configured. Until then,
        use the FOUND Support page (category “Copyright”) so reports reach us reliably.
      </Note>
    </LegalLayout>
  );
}
